import MetaTags from "react-meta-tags"
import React, { useEffect, useState } from "react"

import { Row, Col, Alert, Container, Label, Spinner } from "reactstrap"
import Select from "react-select"
import CarouselPage from "./CarouselPage"

//redux
import { useSelector } from "react-redux"

import { Link } from "react-router-dom"

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

//check active client
const host = window.location.protocol + "//" + window.location.host;
import Config, { ActiveClient } from "../../config";
var LogoSet = (ActiveClient) ? Config[ActiveClient] : Config["cargills"];



var logo;
import(`assets/images/logo/${LogoSet.logoLightPng}`).then(data => {
  logo = host + data.default; //console.log(logo);
});

//
import { Text } from "framework/validators/TextValidation"


//Import config

import DPOTP from "../../framework/components/DPOTP"
import { useHistory } from 'react-router-dom';

//Import firebase
//import firebase from "firebase/app"
import { getAuth, signInWithPopup, GoogleAuthProvider, signInWithCredential } from 'firebase/auth';
import 'firebase/auth'
import { googleProvider, facebookProvider, msProvider, appleProvider, yahooProvider, twitterProvider } from '../../FirebaseConstants';
import SplashScreen24x from "./SplashScreen24x"
import ApiService from "api/apiService"

const Login = props => {

  const [strUsername, setUsername] = useState('')
  const [strPassword, setPassword] = useState('')
  const [selectedGroup, setselectedGroup] = useState(null)
  const [show, setShow] = useState(false)
  const [AlertMsg, setAlertMsg] = useState('')
  const [AlertColor, setAlertColor] = useState('')
  const [uitype, setUitype] = useState('forgot')
  const [resetUsername, setResetUsername] = useState('')
  const [usernameEnable, setUsernameEnable] = useState(false)
  const [buttonshow, setButtonshow] = useState(false)
  const [isLoad, setIsLoad] = useState(false)
  const [loading, setLoading] = useState(false)
  const { error } = useSelector(state => ({
    error: state.Login.error,
  }))

  // This useEffect is used to set the key to 1 after 1 second when the ActiveClient is changed
  // This will re-render the component and the logo will be changed

  let history = useHistory();

  const [optionGroup, setoptionGroup] = useState([
    {
      options: []
    }
  ]);

  useEffect(() => {
    async function fetchPing() {

      try {
        // Use ApiService to make the GET request
        const response = await ApiService.get(`ping`, {}, false); // false for non-authenticated request

        // Log the response data
        console.log(response);
      } catch (error) {
        console.error('Error fetching ping:', error);
      }
    }

    fetchPing();
  }, []);



  useEffect(() => {

    if (optionGroup && optionGroup.length == 1) {
      setselectedGroup(optionGroup[0].value);
    }
  }, [optionGroup]);


  function handleSelectGroup(e) {
    setselectedGroup(e['value'])
  }


  const loadLocDrop = async (userName, password) => {
    try {

      // Set loading state if necessary
      setLoading(true);

      const requestBody = {
        UserName: userName,
        Password: password,
      };

      // Use ApiService to make the POST request
      const response = await ApiService.post('Locations/login/locations', requestBody, false); // false for non-authenticated request

      if (response.status === 200) {
        // Assuming response.data contains the success flag and data
        setoptionGroup(response.data.success ? response.data.data : []);
        setselectedGroup("");
      } else {
        // Handle non-2xx HTTP status codes
        console.error(`Request failed with status ${response.status}`);
        setoptionGroup([]);
        setselectedGroup("");
      }
    } catch (error) {
      // Handle any other errors, including network or API issues
      console.error('Error:', error.message);
      setoptionGroup([]);
      setselectedGroup("");
    } finally {
      // Set loading to false when the API call is completed
      setLoading(false);
    }
  };


  const handleValidSubmit = async (event, values) => {
    if (selectedGroup == null) {
      setAlertColor("danger");
      setAlertMsg("Please select Location !");
      setShow(true);
      return;
    }

    try {
      // Set loading to true when starting the API call
      setLoading(true);
      console.log("Starting login process...");

      const requestBody = {
        "strUsername": strUsername,
        "strPassword": strPassword,
        "strLocation": selectedGroup,
      };

      // Use ApiService to make the POST request
      const response = await ApiService.post(`login`, requestBody, false);
      console.log("Login response:", response);

      switch (response.status) {
        case 200:
          console.log("Login successful, saving auth data");
          localStorage.setItem("authUser", JSON.stringify(response.data.data));  // Assuming response.data has user data
          localStorage.setItem("authToken", response.data.token); // Assuming response.token has the auth token
          if (localStorage.getItem("authPark")) {
            localStorage.removeItem("authPark");
          }
          console.log("About to call getLicenseDetails()");
          await getLicenseDetails(); // Make sure to await this function
          break;

        case 403:
          setAlert("danger", "Invalid Access to Location !");
          break;

        case 404:
          setAlert("danger", response.data.msg);
          if (response.data.msg === "Required Reset" || response.data.msg === "Password Expired") {
            setResetUsername(strUsername);
            setButtonshow(true);
          } else if (response.data.msg === "Locked") {
            // Use ApiService to get user policy data
            const userPolicyResponse = await ApiService.get(`common/userpolicy/${strUsername}`, {}, true);

            if (userPolicyResponse.status) {
              setAlertMsg(`Your account is locked. Account will be unlocked after ${userPolicyResponse.data.data[0].unblockAt.slice(0, 10)} at ${userPolicyResponse.data.data[0].unblockAt.slice(11, 16)}`);
            } else {
              setAlertMsg("Your account is locked. Please contact your administrator.");
            }
          }
          setShow(true);
          break;

        case 400:
          setAlert("danger", "Unexpected error!");
          setShow(true);
          break;

        default:
          setAlertMsg(response.msg);
          break;
      }
    } catch (error) {
      console.error("Login error:", error);
    } finally {
      // Set loading to false when the API call is completed
      setLoading(false);
    }

    function setAlert(color, message) {
      setAlertColor(color);
      setAlertMsg(message);
      setShow(true);
    }
  };


  function search(selectedGroup, optionGroup) {
    //debugger;
    for (var i = 0; i < optionGroup.length; i++) {
      if (optionGroup[i].value == selectedGroup) {
        return optionGroup[i]["label"];
      }
    }
  }

  const loadLocations = async (userName, password) => {

    if (userName == "" || password == "") {
      setAlertMsg("Please enter username and password !");
      setAlertColor("danger");
      setShow(true);
      return;
    }

    loadLocDrop(userName, password)
    return
  }
  
  const getLicenseDetails = async () => {

    try {
      const response = await ApiService.get(`client`, {}, true); // true for authenticated request

      // Handle different HTTP status codes here - this will now work with our Axios configuration
      switch (response.status) {
        case 200:
          if (response.data && response.data.success) {
            localStorage.setItem("Serial", response.data.data.strSerial);
            setIsLoad(true);
            setTimeout(() => {
              setIsLoad(false);
              history.push("/");  // Redirect to home or desired page
            }, 3000);
          } else {
            handleLicenseError(response?.data?.msg || "License verification failed");
          }
          break;
        case 404:
          handleLicenseError(response?.data?.msg || "License not found");
          break;
        default:
          handleLicenseError(response?.data?.msg || "License verification failed with unexpected status");
          break;
      }
    } catch (error) {
      handleLicenseError(error.toString());
    } finally {
      setTimeout(() => {
        setShow(false)
      }, 10000);
    }
  };

  // Helper function to handle license errors
  const handleLicenseError = (errorMsg) => {
    setAlertMsg(errorMsg || "License verification failed");
    setAlertColor("danger");
    setShow(true);
    localStorage.removeItem("authToken");
    localStorage.removeItem("authUser");
    history.push("/login");
  };

  return (
    <React.Fragment>
      {isLoad == false ? <div>
        <MetaTags>
          <title>Login</title>
        </MetaTags>
        <Container fluid className="p-0" style={{ backgroundColor: "" }}>
          <Row className="g-0">

            {ActiveClient === "mypos" ? null : <CarouselPage />}
            <Col xl={3}>
              <div className="auth-full-page-content  p-4" style={{ padding: "2rem" }}>{/*p-md-5 */}
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <div>
                      <Row className="justify-content-center align-items-center">
                        <Col md={4} className="text-center">
                          <Link to="/" className="auth-logo-light">
                            <div className="avatar-md mb-4">
                              <span className="avatar-title rounded-circle bg-light">
                                <img
                                  src={logo}
                                  alt=""
                                  className="rounded-circle"
                                  height="90"
                                  style={{
                                    backgroundColor: '#F8F8FB', // Transparent white
                                  }}
                                />
                              </span>
                            </div>
                          </Link>
                        </Col>
                        <Col md={8}>
                          {/* <div className="text-primary text-center p-4">
  
                              <h5 className="text-primary">{`Welcome to ${Config[Config.ActiveClient].companyName}!`}</h5>
                              <p>{`Sign in to continue to ${Config[Config.ActiveClient].companyName}.`}</p>
                   
                          </div> */}
                          <div className="text-center p-4">
                            {
                              Config.ActiveClient === "mypos"
                                ? (
                                  <>
                                    <h5 style={{ color: "#D70E52" }}>
                                      {`Welcome to ${Config[Config.ActiveClient].companyName}!`}
                                    </h5>
                                    <p style={{ color: "#D70E52" }}>
                                      {`Sign in to continue to ${Config[Config.ActiveClient].loginUIMessage}.`}
                                    </p>
                                  </>
                                )
                                : (
                                  <>
                                    <h5 className="text-primary">{`Welcome to ${Config[Config.ActiveClient].companyName}!`}</h5>
                                    <p className="text-primary">{`Sign in to continue to ${Config[Config.ActiveClient].companyName}.`}</p>
                                  </>
                                )
                            }
                          </div>

                        </Col>
                      </Row>
                    </div>
                    <div className="my-auto">
                      <div className="mt-4">
                        <AvForm
                          className="form-horizontal"
                          onValidSubmit={(e, v) => {
                            handleValidSubmit(e, v)
                          }}
                        >
                          {show ? (
                            <Alert color={AlertColor} role="alert">
                              {AlertMsg}
                            </Alert>
                          ) : null}
                          {error ? <Alert color="danger">{error}</Alert> : null}

                          <div className="mb-3">
                            <AvField
                              name="username"
                              label="Username"
                              value={strUsername}
                              className="form-control"
                              placeholder="Enter username"
                              type="username"
                              onChange={(e) => {
                                setUsername(Text(e.target, 10, true, false, "upper", false))
                                setShow(false)
                              }}
                              // onBlur={async (e) => {
                              //   loadLocations(e.target.value)
                              // }}
                              required
                            />
                          </div>

                          <div className="mb-3">
                            <AvField
                              name="password"
                              label="Password"
                              value={strPassword}
                              type="password"
                              required
                              placeholder="Enter Password"
                              onChange={(e) => {
                                setPassword(Text(e.target, 16, true, true, "normal", false))
                              }}
                              onBlur={(e) => {
                                loadLocations(strUsername, e.target.value)
                              }}
                            />
                          </div>
                          <div className="mb-3">
                            <Label>Select Location</Label>
                            {/* <Select
                              autoFocus
                              backspaceRemovesValue={false}
                              value={selectedGroup}
                              placeholder={selectedGroup ? search(`${selectedGroup}`, optionGroup) : 'Select Here..'}
                              onChange={(e) => {
                                handleSelectGroup(e)
                              }}
                              controlShouldRenderValue={false}
                              hideSelectedOptions={false}
                              isClearable={false}

                              options={optionGroup}
                              classNamePrefix="select2-selection"
                              
                            /> */}
                            <Select
                              autoFocus
                              backspaceRemovesValue={false}
                              value={selectedGroup}
                              placeholder={selectedGroup ? search(`${selectedGroup}`, optionGroup) : 'Select Here..'}
                              onChange={handleSelectGroup}
                              options={optionGroup}
                            />
                          </div>

                          <div className="mt-3 d-grid">
                            <button
                              className="btn btn-primary btn-block"
                              type="submit"
                              style={{ backgroundColor: ActiveClient === "mypos" ? "#D70E52" : "", borderColor: ActiveClient === "mypos" ? "#D70E52" : "" }} // Custom colors based on ActiveClient
                              disabled={loading} // Disable the button while loading
                            >
                              {loading ? (
                                <>
                                  <Spinner size="sm" className="ms-2" color="light" />
                                </>
                              ) : (
                                "Log In"
                              )}
                            </button>
                          </div>

                          <div className="mt-4 text-center ">
                            <Label onClick={(e) => {
                              setButtonshow(true)
                              setUitype("forgot")
                              setUsernameEnable(true)
                            }} className="text-muted" style={{ cursor: 'pointer' }}>
                              <i className="mdi mdi-lock me-1" style={{ cursor: 'pointer' }} />
                              Forgot your password?
                            </Label>
                          </div>
                        </AvForm>
                      </div>
                    </div>

                    <div className="mt-5 text-center">
                      <p style={{ display: "none" }}>
                        Don&#39;t have an account ?{" "}
                        <Link to="register" className="fw-medium text-primary">
                          {" "}
                          Signup now{" "}
                        </Link>{" "}
                      </p>
                      <p>
                        © {new Date().getFullYear()} <a href={Config[Config.ActiveClient].webUrl}>{Config[Config.ActiveClient].fullName}</a>{" "}
                      </p>
                      <p>
                        Version {process.env.REACT_APP_VERSION}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            {ActiveClient === "mypos" ? <CarouselPage /> : null}
          </Row>
        </Container>
        <DPOTP
          confirm_both={buttonshow}
          onCancel={() => {
            setButtonshow(false)
          }}
          uitype={uitype}
          usercode={resetUsername}
          usernameEnable={usernameEnable}
          setUsernameEnable={setUsernameEnable}
        />
      </div> : <SplashScreen24x />}
    </React.Fragment>
  )
}

export default Login
